/**
 * Pago en Cuotas - Multi-step Logic (Dinámico)
 * Lee configuración de bancos/cuotas desde el DOM (schema Shopify)
 */
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  // ==========================================
  // CONFIGURACIÓN DESDE DATA ATTRIBUTES
  // ==========================================
  var page = document.querySelector('.cuotas-page');
  if (!page) return;

  var MINIMUM_AMOUNT = parseInt(page.dataset.minimum) || 1000;
  var WHATSAPP = page.dataset.whatsapp || '+502 2310 9336';
  var ENDPOINT_URL = page.dataset.endpoint || '';
  var API_KEY = page.dataset.apikey || '';
  var HMAC_SECRET = page.dataset.secret || '';

  var currentStep = 1;
  var selectedBank = '';
  var selectedCuotas = 0;
  var cartTotal = 0;
  var customerData = {};

  // DOM elements
  var steps = page.querySelectorAll('.cuotas-step');
  var contents = page.querySelectorAll('.step-content');
  var bancoCards = page.querySelectorAll('.banco-card');
  var cuotasGrids = page.querySelectorAll('.cuotas-options');
  var simAmount = page.querySelector('.sim-amount');
  var simDetail = page.querySelector('.sim-detail');
  var simTotal = page.querySelector('.sim-total strong');

  // ==========================================
  // INITIALIZE
  // ==========================================
  initBankSelection();
  getCartTotal();
  bindBankSelection();
  bindCuotaSelection();
  bindButtons();
  bindLiveValidation();

  function initBankSelection() {
    // Read initial selected bank
    var firstCard = page.querySelector('.banco-card.selected');
    if (firstCard) {
      var radio = firstCard.querySelector('input');
      if (radio) {
        selectedBank = radio.value;
        var cuotasStr = radio.dataset.cuotas || '';
        var firstCuota = cuotasStr.split(',')[0];
        if (firstCuota) selectedCuotas = parseInt(firstCuota.trim());
      }
    }
  }

  // ==========================================
  // CART - Only eligible items
  // ==========================================
  var eligibleData = null;

  // Lee SIEMPRE el estado real del DOM (evita depender de una lectura temprana
  // que pudo llenarse mal por caché del asset o por una condición de carrera).
  function readEligibleFromDOM() {
    var jsonEl = document.getElementById('cuotas-eligible-items');
    if (!jsonEl) {
      console.warn('[cuotas] No se encontró #cuotas-eligible-items en el DOM');
      return { items: [], eligible_count: 0, eligible_total: 0 };
    }
    try {
      var data = JSON.parse(jsonEl.textContent);
      data.items = data.items || [];
      data.cart_items = data.cart_items || [];
      data.eligible_count = data.items.length;
      data.eligible_total = data.eligible_total || 0;
      data.cart_total = data.cart_total || 0;
      data.full_cart_mode = data.full_cart_mode === true || data.full_cart_mode === 'true';
      return data;
    } catch (e) {
      console.error('[cuotas] Error parseando #cuotas-eligible-items:', e, jsonEl.textContent);
      return { items: [], cart_items: [], eligible_count: 0, eligible_total: 0, cart_total: 0, full_cart_mode: false };
    }
  }

  // Devuelve los items que se van a financiar segun el modo:
  // - full_cart_mode: TODO el carrito (siempre que haya al menos 1 elegible).
  // - clasico: solo los elegibles.
  function getFinanceItems() {
    if (!eligibleData) return [];
    if (eligibleData.full_cart_mode && eligibleData.eligible_count > 0) {
      return eligibleData.cart_items;
    }
    return eligibleData.items;
  }

  function getCartTotal() {
    eligibleData = readEligibleFromDOM();
    // En modo "todo el carrito" el monto base es el total del carrito completo;
    // en modo clasico es el total de los elegibles.
    if (eligibleData.full_cart_mode && eligibleData.eligible_count > 0) {
      cartTotal = eligibleData.cart_total;
    } else {
      cartTotal = eligibleData.eligible_total;
    }
    updateSimulation();
    checkMinimum();
  }

  function checkMinimum() {
    if (eligibleData && eligibleData.eligible_count === 0) {
      page.innerHTML =
        '<div class="cuotas-minimum-notice">' +
        '<h2>Pago en Cuotas</h2>' +
        '<p>No tienes productos elegibles para pago en cuotas en tu carrito.</p>' +
        '<a href="/collections/all" class="btn-cuotas-primary" style="display:inline-block;text-decoration:none;margin-top:16px;">Seguir comprando</a>' +
        '</div>';
      return;
    }
    if (cartTotal < MINIMUM_AMOUNT) {
      page.innerHTML =
        '<div class="cuotas-minimum-notice">' +
        '<h2>Pago en Cuotas</h2>' +
        '<p>El pago en cuotas está disponible para compras iguales o mayores a <strong>Q ' + formatNumber(MINIMUM_AMOUNT) + '</strong>.</p>' +
        '<p>Total elegible en tu carrito: <strong>Q ' + formatNumber(cartTotal) + '</strong></p>' +
        '<a href="/collections/all" class="btn-cuotas-primary" style="display:inline-block;text-decoration:none;margin-top:16px;">Seguir comprando</a>' +
        '</div>';
    }
  }

  // ==========================================
  // BANK SELECTION
  // ==========================================
  function bindBankSelection() {
    for (var i = 0; i < bancoCards.length; i++) {
      bancoCards[i].addEventListener('click', handleBankClick);
    }
  }

  function handleBankClick(e) {
    var card = e.currentTarget;
    // Deselect all
    for (var i = 0; i < bancoCards.length; i++) {
      bancoCards[i].classList.remove('selected');
    }
    card.classList.add('selected');

    var radio = card.querySelector('input');
    if (radio) {
      radio.checked = true;
      selectedBank = radio.value;
    }

    // Toggle cuotas grids: hide all, show the one for this bank
    var bankIndex = Array.prototype.indexOf.call(bancoCards, card);
    for (var j = 0; j < cuotasGrids.length; j++) {
      cuotasGrids[j].style.display = (j === bankIndex) ? 'grid' : 'none';
    }

    // Auto-select first cuota of new grid
    if (cuotasGrids[bankIndex]) {
      var allBtns = cuotasGrids[bankIndex].querySelectorAll('.cuota-btn');
      for (var k = 0; k < allBtns.length; k++) {
        allBtns[k].classList.remove('selected');
      }
      if (allBtns.length > 0) {
        allBtns[0].classList.add('selected');
        var firstRadio = allBtns[0].querySelector('input');
        if (firstRadio) {
          firstRadio.checked = true;
          selectedCuotas = parseInt(firstRadio.value);
        }
      }
    }
    updateSimulation();
  }

  // ==========================================
  // CUOTA SELECTION
  // ==========================================
  function bindCuotaSelection() {
    var allCuotaBtns = page.querySelectorAll('.cuota-btn');
    for (var i = 0; i < allCuotaBtns.length; i++) {
      allCuotaBtns[i].addEventListener('click', handleCuotaClick);
    }
  }

  function handleCuotaClick(e) {
    var btn = e.currentTarget;
    var parent = btn.closest('.cuotas-options');
    if (!parent) return;

    var siblings = parent.querySelectorAll('.cuota-btn');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.remove('selected');
    }
    btn.classList.add('selected');

    var radio = btn.querySelector('input');
    if (radio) {
      radio.checked = true;
      selectedCuotas = parseInt(radio.value);
    }
    updateSimulation();
  }

  // ==========================================
  // SIMULATION
  // ==========================================
  function updateSimulation() {
    if (!cartTotal || !selectedCuotas) return;
    var monthly = cartTotal / selectedCuotas;
    if (simAmount) simAmount.textContent = 'Q ' + formatNumber(monthly);
    if (simDetail) simDetail.textContent = 'En ' + selectedCuotas + ' cuotas · Total Q ' + formatNumber(cartTotal) + ' (estimado)';
    if (simTotal) simTotal.textContent = 'Q ' + formatNumber(cartTotal);
  }

  // ==========================================
  // NAVIGATION
  // ==========================================
  function bindButtons() {
    var primaryBtns = page.querySelectorAll('.btn-cuotas-primary');
    for (var i = 0; i < primaryBtns.length; i++) {
      primaryBtns[i].addEventListener('click', handlePrimaryClick);
    }
    var secondaryBtns = page.querySelectorAll('.btn-cuotas-secondary');
    for (var j = 0; j < secondaryBtns.length; j++) {
      secondaryBtns[j].addEventListener('click', handleSecondaryClick);
    }
    var outlineBtn = page.querySelector('.btn-cuotas-outline');
    if (outlineBtn) {
      outlineBtn.addEventListener('click', function () { window.location.href = '/'; });
    }
  }

  function handlePrimaryClick() {
    if (currentStep === 1) goToStep(2);
    else if (currentStep === 2) {
      if (validateForm()) { populatePreCheckout(); goToStep(3); }
    }
    else if (currentStep === 3) submitOrder();
  }

  function handleSecondaryClick() {
    if (currentStep === 1) window.location.href = '/cart';
    else if (currentStep === 2) goToStep(1);
    else if (currentStep === 3) goToStep(2);
  }

  function goToStep(step) {
    currentStep = step;
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.remove('active', 'completed');
      if (i + 1 < step) steps[i].classList.add('completed');
      if (i + 1 === step) steps[i].classList.add('active');
    }
    for (var j = 0; j < contents.length; j++) {
      contents[j].classList.remove('active');
    }
    var target = page.querySelector('.step-' + step + '-content');
    if (target) target.classList.add('active');

    var stepper = page.querySelector('.cuotas-stepper');
    var header = page.querySelector('.cuotas-header');
    if (step === 4) {
      if (stepper) stepper.style.display = 'none';
      if (header) header.style.display = 'none';
    } else {
      if (stepper) stepper.style.display = 'flex';
      if (header) header.style.display = 'block';
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ==========================================
  // FORM VALIDATION
  // ==========================================
  function validateForm() {
    var form = page.querySelector('.cuotas-form');
    if (!form) return false;

    var nombre = form.querySelector('[data-field="nombre"]');
    var dpi = form.querySelector('[data-field="dpi"]');
    var celular = form.querySelector('[data-field="celular"]');
    var correo = form.querySelector('[data-field="correo"]');

    // Limpiar errores previos
    var oldErrors = form.querySelectorAll('.form-error');
    for (var i = 0; i < oldErrors.length; i++) oldErrors[i].remove();
    var allInputs = form.querySelectorAll('input');
    for (var j = 0; j < allInputs.length; j++) allInputs[j].style.borderColor = '#ddd';

    var valid = true;
    var firstInvalid = null;
    if (!validateField('nombre', nombre)) { valid = false; firstInvalid = firstInvalid || nombre; }
    if (!validateField('dpi', dpi)) { valid = false; firstInvalid = firstInvalid || dpi; }
    if (!validateField('celular', celular)) { valid = false; firstInvalid = firstInvalid || celular; }
    if (!validateField('correo', correo)) { valid = false; firstInvalid = firstInvalid || correo; }

    if (valid) {
      customerData = {
        nombre: nombre.value.trim(),
        dpi: dpi.value.replace(/[\s\-]/g, ''),
        celular: normalizeCelular(celular.value),
        correo: correo.value.trim()
      };
    } else if (firstInvalid) {
      // Llevar al usuario al primer campo con error (mejor que un alert al final)
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { firstInvalid.focus({ preventScroll: true }); } catch (e) { firstInvalid.focus(); }
    }
    return valid;
  }

  // Normaliza el celular al formato de 8 dígitos locales (quita 502 y símbolos).
  function normalizeCelular(value) {
    var c = value.replace(/[\s\-\+\(\)]/g, '');
    if (c.indexOf('502') === 0 && c.length > 8) c = c.substring(3);
    return c;
  }

  // Validación individual por campo (reusable para tiempo real y submit)
  function validateField(type, input) {
    if (!input) return false;
    var val = input.value.trim();
    var msg = null;

    if (type === 'nombre') {
      if (!val) msg = 'El nombre es requerido';
      else if (val.length < 3) msg = 'El nombre es muy corto';
      else if (!/^[\p{L}\s.\-']+$/u.test(val)) msg = 'El nombre tiene caracteres no válidos';
    } else if (type === 'dpi') {
      var d = val.replace(/[\s\-]/g, '');
      if (!d) msg = 'El DPI es requerido';
      else if (!/^\d+$/.test(d)) msg = 'El DPI solo debe tener números';
      else if (d.length < 8 || d.length > 13) msg = 'El DPI debe tener entre 8 y 13 dígitos';
    } else if (type === 'celular') {
      var c = val.replace(/[\s\-\+\(\)]/g, '');
      // Quitar código de país 502 si viene incluido, para validar los 8 dígitos locales
      if (c.indexOf('502') === 0 && c.length > 8) c = c.substring(3);
      if (!c) msg = 'El celular es requerido';
      else if (!/^\d+$/.test(c)) msg = 'El celular solo debe tener números';
      // Guatemala: 8 dígitos que empiezan en 2-7 (Shopify rechaza otros formatos)
      else if (!/^[2-7]\d{7}$/.test(c)) msg = 'Ingresa un celular de Guatemala válido (8 dígitos)';
    } else if (type === 'correo') {
      if (!val) msg = 'El correo es requerido';
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) msg = 'Ingresa un correo válido';
    }

    // Limpiar error previo del campo
    var existing = input.parentNode.querySelector('.form-error');
    if (existing) existing.remove();

    if (msg) {
      showError(input, msg);
      return false;
    }
    input.style.borderColor = '#4caf50'; // verde = válido
    return true;
  }

  // Validación en tiempo real
  function bindLiveValidation() {
    var form = page.querySelector('.cuotas-form');
    if (!form) return;
    var fields = form.querySelectorAll('[data-field]');
    for (var i = 0; i < fields.length; i++) {
      (function (input) {
        var type = input.getAttribute('data-field');
        // Restringir DPI y celular a solo números
        if (type === 'dpi' || type === 'celular') {
          input.addEventListener('input', function () {
            this.value = this.value.replace(/[^\d]/g, '');
          });
        }
        // Validar al salir del campo
        input.addEventListener('blur', function () {
          if (this.value.trim() !== '') validateField(type, this);
        });
      })(fields[i]);
    }
  }

  function showError(input, msg) {
    if (!input) return;
    input.style.borderColor = '#e53935';
    var error = document.createElement('span');
    error.className = 'form-error';
    error.textContent = msg;
    error.style.cssText = 'color:#e53935;font-size:12px;margin-top:4px;display:block;';
    input.parentNode.appendChild(error);
  }

  // ==========================================
  // PRE-CHECKOUT - Only eligible items
  // ==========================================
  function populatePreCheckout() {
    var step3 = page.querySelector('.step-3-content');
    if (!step3) return;
    var monthly = cartTotal / selectedCuotas;

    // Releer del DOM para reflejar los items reales.
    eligibleData = readEligibleFromDOM();

    var financeItems = getFinanceItems();
    var products = 'Productos del carrito';
    if (financeItems && financeItems.length > 0) {
      products = financeItems.map(function (item) { return item.title; }).join(' + ');
    }
    renderCheckout(step3, products, monthly);
  }

  function renderCheckout(step3, products, monthly) {
    var table = step3.querySelector('.checkout-table');
    if (table) {
      table.innerHTML =
        '<tr><td class="label">Productos</td><td class="value">' + products + '</td></tr>' +
        '<tr><td class="label">Total carrito</td><td class="value">Q ' + formatNumber(cartTotal) + '</td></tr>' +
        '<tr><td class="label">Banco</td><td class="value">' + selectedBank + '</td></tr>' +
        '<tr><td class="label">Cuotas</td><td class="value">' + selectedCuotas + ' cuotas</td></tr>' +
        '<tr class="highlight-row"><td class="label">Pago mensual estimado</td><td class="value highlight">Q ' + formatNumber(monthly) + ' / mes</td></tr>';
    }
    var personal = step3.querySelector('.checkout-personal');
    if (personal) {
      personal.innerHTML =
        '<div class="personal-row"><span class="label">Nombre:</span><span class="value">' + customerData.nombre + '</span><span class="label">DPI:</span><span class="value">' + customerData.dpi + '</span></div>' +
        '<div class="personal-row"><span class="label">Celular:</span><span class="value">' + customerData.celular + '</span><span class="label">Correo:</span><span class="value">' + customerData.correo + '</span></div>';
    }
    var summary = page.querySelector('.step2-summary p');
    if (summary) {
      summary.textContent = selectedBank + ' · ' + selectedCuotas + ' cuotas · Q ' + formatNumber(monthly) + '/mes · Total Q ' + formatNumber(cartTotal);
    }
  }

  // ==========================================
  // SUBMIT ORDER - Only eligible items
  // ==========================================
  function submitOrder() {
    var confirmBtn = page.querySelector('.step-3-content .btn-cuotas-primary');
    if (confirmBtn) { confirmBtn.disabled = true; confirmBtn.textContent = 'Procesando...'; }

    // Releer el estado real del DOM en el momento del envío (no confiar en la
    // lectura inicial, que pudo quedar desincronizada por caché del asset).
    eligibleData = readEligibleFromDOM();

    // Regla base: siempre debe existir AL MENOS un producto elegible.
    if (!eligibleData || eligibleData.eligible_count === 0) {
      console.warn('[cuotas] submitOrder: sin items elegibles al momento del envío', eligibleData);
      showStepError('No hay productos elegibles para pago en cuotas.');
      if (confirmBtn) { confirmBtn.disabled = false; confirmBtn.textContent = 'Confirmar pago en cuotas'; }
      return;
    }

    // Items a financiar segun el modo (todo el carrito o solo elegibles).
    var financeItems = getFinanceItems();
    if (!financeItems || financeItems.length === 0) {
      console.warn('[cuotas] submitOrder: sin items para financiar', eligibleData);
      showStepError('No hay productos para pago en cuotas.');
      if (confirmBtn) { confirmBtn.disabled = false; confirmBtn.textContent = 'Confirmar pago en cuotas'; }
      return;
    }

    clearStepError();

    var cartItems = financeItems.map(function (item) {
      return { variant_id: item.variant_id, quantity: item.quantity };
    });
    sendOrder(cartItems, confirmBtn);
  }

  function sendOrder(cartItems, confirmBtn) {
    var payload = {
      nombre: customerData.nombre,
      dpi: customerData.dpi,
      celular: customerData.celular,
      correo: customerData.correo,
      banco: selectedBank,
      cuotas: selectedCuotas,
      cart_items: cartItems,
      cart_total: cartTotal,
      full_cart_mode: (eligibleData && eligibleData.full_cart_mode && eligibleData.eligible_count > 0) ? true : false
    };

    var timestamp = Math.floor(Date.now() / 1000).toString();
    var body = JSON.stringify(payload);
    var idempotencyKey = generateUUID();

    signRequest(timestamp, body).then(function (signature) {
      return fetch(ENDPOINT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Api-Key': API_KEY,
          'X-Signature': signature,
          'X-Timestamp': timestamp,
          'X-Idempotency-Key': idempotencyKey
        },
        body: body
      });
    })
      .then(function (r) {
        if (r.status === 409) return r.json().then(function (d) { throw new Error(d.error); });
        if (r.status === 429) throw new Error('Demasiadas solicitudes. Espera unos minutos.');
        if (r.status === 422) return r.json().then(function (d) {
          var msg = d.error || 'Datos inválidos';
          if (d.details && d.details.length) { msg = d.details.join('\n'); }
          throw new Error(msg);
        });
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.error || 'Error del servidor'); });
        return r.json();
      })
      .then(function (data) {
        if (data.success) {
          var ordenEl = page.querySelector('.orden-number strong');
          if (ordenEl) ordenEl.textContent = data.order_name || '#' + data.order_id;
          goToStep(4);
        } else {
          throw new Error(data.error || 'Error desconocido');
        }
      })
      .catch(function (err) {
        console.error('Error:', err);
        showStepError(err.message || 'Error de conexión. Intenta de nuevo.');
        if (confirmBtn) { confirmBtn.disabled = false; confirmBtn.textContent = 'Confirmar pago en cuotas'; }
      });
  }

  // Muestra un mensaje de error inline dentro del paso 3 (en vez de un alert).
  function showStepError(message) {
    var step3 = page.querySelector('.step-3-content');
    if (!step3) return;
    var box = step3.querySelector('.cuotas-step-error');
    if (!box) {
      box = document.createElement('div');
      box.className = 'cuotas-step-error';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'background:#fdecea;border:1px solid #f5c6cb;color:#b71c1c;padding:12px 16px;border-radius:8px;margin:0 0 16px;font-size:14px;line-height:1.4;white-space:pre-line;';
      var buttons = step3.querySelector('.cuotas-buttons');
      if (buttons) { step3.insertBefore(box, buttons); }
      else { step3.appendChild(box); }
    }
    box.textContent = message;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearStepError() {
    var box = page.querySelector('.step-3-content .cuotas-step-error');
    if (box) box.remove();
  }

  // ==========================================
  // SECURITY
  // ==========================================
  function signRequest(timestamp, body) {
    var payload = timestamp + '.' + body;
    var encoder = new TextEncoder();
    var keyData = encoder.encode(HMAC_SECRET);
    var msgData = encoder.encode(payload);

    return crypto.subtle.importKey(
      'raw', keyData, { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']
    ).then(function (key) {
      return crypto.subtle.sign('HMAC', key, msgData);
    }).then(function (sig) {
      return Array.from(new Uint8Array(sig)).map(function (b) {
        return b.toString(16).padStart(2, '0');
      }).join('');
    });
  }

  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      var v = (c === 'x') ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  function formatNumber(num) {
    return num.toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
});
